<router-outlet></router-outlet>
<div #mainContainer>
    <!-- Aquí se inyecta el componente principal de la aplicación -->
</div>